import styles from './ShareButton.module.scss';
import iconShare from '@/img/share.svg';
import { useCallback } from 'react';
import { useAnalyticsContext } from '@/contexts/analytics.context';
import ANALYTICS_EVENTS from '@/constants/analytics_events';
import { useToast } from '@/contexts/toast.context';
import useShare from '@/core/hooks/useShare';
import { getAnalytics, logEvent } from 'firebase/analytics';

type ShareButtonProps = {
  model: ShareModel;
};

const ShareButton = ({ model }: ShareButtonProps) => {
  const { showToast } = useToast();
  const analytics = getAnalytics();

  const share = useShare();

  const handleShareClick = useCallback(async () => {
    // Obtener linkableType e linkableId del modelo
    const linkableType = model.getLinkableType();
    const linkableId = model.getLinkableId();

    console.log("Share button clicked for:", { linkableType, linkableId });

    if (!linkableId) {
      console.error('No se pudo obtener el ID del elemento a compartir');
      showToast('Error al procesar el elemento', 'error');
      return;
    }

    try {
      // Generar el deep link y obtener el resultado directamente
      const generatedLink = await share.loadDeepLink(
        linkableType,
        linkableId,
        model.getLongLink(),
        model.getTitle(),
        model.getDescription(),
        model.getImage(),
      );

      console.log("Generated link:", generatedLink);

      // Si se generó correctamente, copiar al portapapeles
      if (generatedLink) {
        const textArea = document.createElement('textarea');
        textArea.style.position = 'fixed';
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = '0';
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = model.getMessage(generatedLink);

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          const success = document.execCommand('copy');
          if (success) {
            logEvent(analytics, ANALYTICS_EVENTS.SHARE_INVITE_CODE);
            model.sendFirebaseEvents();
            showToast('El enlace se ha copiado en el portapapeles', 'success');
            console.log("Link copied successfully:", generatedLink);
          } else {
            console.error("Failed to copy link");
            showToast('No se ha podido copiar el enlace', 'error');
          }
        } catch (err) {
          console.error("Error copying link:", err);
          showToast('No se ha podido copiar el enlace', 'error');
        }

        document.body.removeChild(textArea);
      } else {
        console.error("No link available to copy");
        showToast('No hay enlace disponible para copiar', 'error');
      }
    } catch (error) {
      console.error("Error in share process:", error);
      showToast('Error al generar el enlace de compartir', 'error');
    }
  }, [model, share, analytics, showToast]);

  return (
    <button
      className={`${styles.share}`}
      disabled={share.isLoading}
      onClick={handleShareClick}
    >
      <img className={styles.icon} src={iconShare} />
    </button>
  );
};

export default ShareButton;
